import { Grid, Stack, styled } from "@mui/material";
import { customColors } from "models/customColors";

const responsiveFontSize = `  
  font-family: sans-serif;
  font-weight: 500;
  font-size: 13px;
    
  @media (max-width: 1600px) {
    font-size: 12px;
  }

  @media (max-width: 1440px) {
    font-size: 11px;
  }

  @media (max-width: 1280px) {
    font-size: 10px;
  }
`;

export const RecordsHolder = styled(Grid)`
  flex: 1 1 auto;

  min-height: 260px;
  height: calc(100vh - 405px);
  min-width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  border: thin solid lightgray;
  background-color: ${customColors.white};

  @media screen and (max-width: 1279px) {
    height: 100%;
  }
`;

export const Record = styled(Grid)`
  padding: 5px 24px;

  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    background-color: ${customColors.selector};
  }

  cursor: pointer;
`;

export const RecordItem = styled(Grid)`
  color: ${customColors.text};
  font-style: normal;
  font-weight: 400;

  text-align: left;

  word-wrap: break-word;

  ${responsiveFontSize}
`;

export const Header = styled(Grid)`
  margin-top: 10px;
  padding: 16px 40px 16px 24px;

  border-top: thin solid lightgray;
  border-left: thin solid lightgray;
  border-top-left-radius: 5px;
  border-right: thin solid lightgray;
  border-top-right-radius: 5px;
  font-weight: bold;

  &:hover {
    color: ${customColors.selector};
  }
`;

export const HeaderItemWithoutSorter = styled(Stack)`
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 112.5% */

  color: ${customColors.gridHeaderText};
  user-select: none;

  word-wrap: break-word;
  word-break: break-all;

  ${responsiveFontSize}
`;

export const HeaderItem = styled(HeaderItemWithoutSorter)`
  cursor: pointer;

  &:hover {
    color: ${customColors.mainColor};
  }
`;

export const PaginationContainer = styled(Stack)`
  padding: 5px 20px;

  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  border-bottom: thin solid lightgray;
  border-left: thin solid lightgray;
  border-bottom-left-radius: 5px;
  border-right: thin solid lightgray;
  border-bottom-right-radius: 5px;
`;

export const RecordsPerPageSelector = styled(Stack)`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;

  font-size: 12px;
  font-style: normal;
`;

export const NoDataHolder = styled(Stack)`
  flex: 1 1 auto;
  height: 50%;
  min-height: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;

  color: ${customColors.grayText};
`;
